import TCreateEditAwardVideo from "types/Award/createEditAwardVideo";

const awardVideoItemMapper = (formValues: any): TCreateEditAwardVideo => ({
  mediaUrl:
    typeof formValues.mediaUrl === "string" ? formValues.mediaUrl : undefined,
  removeMediaUrl: formValues.removeMediaUrl,
});

export default awardVideoItemMapper;
